export enum EditUserNotificationType {
  ERROR = 'ERROR',
  EDIT_NAME = 'EDIT_NAME',
  ASSIGN_ROLES = 'ASSIGN_ROLES',
  ASSIGN_TO_GROUPS = 'ASSIGN_TO_GROUPS',
  REMOVE_FROM_ROLE = 'REMOVE_FROM_ROLE',
  REMOVE_FROM_GROUP = 'REMOVE_FROM_GROUP',
}
